import deepMerge from 'deepmerge';
import { handleActions } from 'redux-actions';
import { assoc, converge } from 'ramda';

import { USER_FETCHED } from 'app/features/user/actionTypes';
import { FETCH_DELTA_CONFIG_SUCCESS } from 'app/features/deltaConfig/actionTypes';
import { LANDING_PAGE } from 'app/features/deltaConfig/constants';
import { pickState, pathOrFromPayload } from 'app/reducers/helpers';

const initialState = {
  titleKey: 'landing_heroblock_title',
  imageUrl: `${window.etp.config.assetsUrl}img/landing/hero_bg.png`,
  imageUrl2X: `${window.etp.config.assetsUrl}img/landing/hero_bg@2x.png`,
  titleColor: 'white',
  isPerksVisible: true,
};

const heroBlock = handleActions(
  {
    [USER_FETCHED]: (state, { payload: user }) =>
      assoc(
        'button',
        {
          textKey: user.isDirectToPay
            ? 'buttons_get_premium'
            : 'buttons_free_trial',
        },
        initialState,
      ),
    [FETCH_DELTA_CONFIG_SUCCESS]: converge(deepMerge, [
      pickState,
      pathOrFromPayload({}, [LANDING_PAGE, 'heroBlock']),
    ]),
  },
  initialState,
);

export { initialState };

export default heroBlock;
